import * as React from 'react';
import * as MuiIcons from '@mui/icons-material';
import * as PXBColors from '@brightlayer-ui/colors';
import * as PXBCore from '@brightlayer-ui/react-components/core';
import { getIcon } from '../../lib/icons';

import { DeviceListData, DeviceVendor } from '../../types/device';
import { ConditionIndexBadge } from '../ListGroups/ConditionIndex';
import { RelativeConditionIndexProvider } from '../../data/DataProviders/RelativeConditionIndexProvider';
import * as MuiCore from '@mui/material';
import { Status } from '../../types';
import { StatusTag } from '../StatusTag/StatusTag';
import { useSignalRData } from '../../data/DataProviders/SignalRDataProvider';

export const DeviceListItem: React.FC<{
    value: DeviceListData;
    isLast: boolean;
    onClick?: () => void;
}> = (props) => {
    const deviceType = props.value.iconClass; 
    const realTimeData = useSignalRData();
    const [deviceStatus, setDeviceStatus] = React.useState<boolean | null>(false);

    React.useEffect(() => {
         setDeviceStatus(props.value.status);
    }, [props.value]);

    React.useEffect(() => { 
        if (realTimeData && realTimeData.locations) {
         realTimeData.locations.forEach((locationsData) => { 
            locationsData.sites.forEach((sitesData) => { 
                if(sitesData.devices){
                    sitesData.devices.forEach((devices) => { 
                        if(devices.deviceId === props.value.id){
                            setDeviceStatus(devices.status); 
                        }
                    })
                }
            });
        });
      }  
    }, [realTimeData]); // eslint-disable-line react-hooks/exhaustive-deps

    return (
        <div data-testid="device-list-item" style={{ wordWrap: 'break-word', whiteSpace: 'pre-wrap', wordBreak: 'break-all' }} >
            <PXBCore.InfoListItem
                title=""
                backgroundColor={PXBColors.white[50]}
                divider={!props.isLast ? 'full' : undefined}
                subtitleSeparator="<"
                icon={React.createElement(getIcon(deviceType, 'DeviceUnknown'))}
                iconColor={PXBColors.gray[500]}
                onClick={(): void => {
                    if (props.onClick) {
                        props.onClick();
                    }
                }}
                leftComponent={
                    <div>
                        <MuiCore.Typography variant="body2" display="inline" style={{ lineHeight: 1.25 }}>
                            {props.value.name}
                        </MuiCore.Typography>
                        <MuiCore.Typography
                            variant="body2"
                            display="inline"
                            style={{ marginLeft: '5px', fontWeight: 600, lineHeight: 1.25 }}
                        >
                            {props.value.type}
                        </MuiCore.Typography>
                        <MuiCore.Typography variant="body2" display="block" style={{ lineHeight: 1.25 }}>
                            {[...props.value.path].reverse().join(' < ')}
                        </MuiCore.Typography>
                    </div>
                }
                rightComponent={
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                        
                            {props.value.type?.toLowerCase() === DeviceVendor.Insulgard && (
                                <RelativeConditionIndexProvider deviceId={props.value.id}>
                                <ConditionIndexBadge />
                                </RelativeConditionIndexProvider>

                            )}                       
                      
                        { deviceStatus ? <StatusTag status={Status.Online}/> : 
                          <StatusTag status={Status.Offline}/> }
                        <MuiCore.IconButton style={{ marginLeft: 16 }}>
                            <MuiIcons.ChevronRight />
                        </MuiCore.IconButton>
                    </div>
                }
            />
        </div>
    );
};
